export const api = "https://insta-clone-nf7o.onrender.com";
